export default "__VITE_PUBLIC_ASSET__2543c669__"